import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";
import { showToast } from "./ToastSlice";

export const triggerCallAnalysis = createAsyncThunk(
  "callAnalysis/trigger",
  async (callHistoryId, { rejectWithValue, dispatch }) => {
    try {
      await api.post(`/ai/analyze-call/${callHistoryId}`);
      return callHistoryId;
    } catch (err) {
      dispatch(showToast({ message: err.response?.data?.message || "Failed to start analysis", type: "error" }));
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCallAnalysis = createAsyncThunk(
  "callAnalysis/fetch",
  async (callHistoryId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/ai/analyze-call/${callHistoryId}`);
      return { callHistoryId, data: response.data.data };
    } catch (err) {
      if (err.response?.status === 404) return { callHistoryId, data: null };
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const callAnalysisSlice = createSlice({
  name: "callAnalysis",
  initialState: {
    byCallId: {},
  },
  reducers: {
    clearCallAnalysis(state, action) {
      delete state.byCallId[action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(triggerCallAnalysis.pending, (state, action) => {
        const id = action.meta.arg;
        state.byCallId[id] = { loading: true, status: "processing", data: null, error: null };
      })
      .addCase(triggerCallAnalysis.fulfilled, (state, action) => {
        const id = action.payload;
        state.byCallId[id] = { loading: true, status: "processing", data: null, error: null };
      })
      .addCase(triggerCallAnalysis.rejected, (state, action) => {
        const id = action.meta.arg;
        state.byCallId[id] = { loading: false, status: "failed", data: null, error: action.payload };
      })
      .addCase(fetchCallAnalysis.pending, (state, action) => {
        const id = action.meta.arg;
        if (!state.byCallId[id]) {
          state.byCallId[id] = { loading: true, status: null, data: null, error: null };
        } else {
          state.byCallId[id].loading = true;
          state.byCallId[id].status = state.byCallId[id].data?.status || null;
        }
      })
      .addCase(fetchCallAnalysis.fulfilled, (state, action) => {
        const { callHistoryId, data } = action.payload;
        state.byCallId[callHistoryId] = {
          loading: false,
          status: data?.status || null,
          data: data,
          error: null,
        };
      })
      .addCase(fetchCallAnalysis.rejected, (state, action) => {
        const id = action.meta.arg;
        state.byCallId[id] = { loading: false, status: "failed", data: null, error: action.payload };
      });
  },
});

export const { clearCallAnalysis } = callAnalysisSlice.actions;
export default callAnalysisSlice.reducer;
